import { render, staticRenderFns } from "./BusinessDocuments.vue?vue&type=template&id=8c50e0f2&scoped=true"
import script from "./BusinessDocuments.vue?vue&type=script&lang=js"
export * from "./BusinessDocuments.vue?vue&type=script&lang=js"
import style0 from "./BusinessDocuments.vue?vue&type=style&index=0&id=8c50e0f2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c50e0f2",
  null
  
)

export default component.exports